export function SplashPage() {
  return (
    <div style={{ display: "flex", width: "100%", height: "100%", justifyContent: "center", alignItems: "center" }}>
      <img src="/apcoa-logo.png" style={{ width: "100%", height: "100%", maxWidth: "436px", maxHeight: "180px" }} />
    </div>
  );
}
